module.exports = __webpack_public_path__ + "h5/img/di8.a7ca0d32.png";